import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import ActivityEntry from './ActivityEntry';

import Config from '../../utils/config';

class ActivityList extends React.Component {
    constructor(props) {
        super(props);
        this.shuffle = null;

        this.hideBanner = this.hideBanner.bind(this);
    }

    componentWillMount() {
        this.setState({
            bannerVisible: true,
        });
    }

    hideBanner() {
        this.setState({
            bannerVisible: false,
        });
    }

    loadNextPage() {
        const {page, pageChangeCallback} = this.props;

        pageChangeCallback(page + 1);
    }

    filterActivities(activities, intentKey) {
        return activities.filter(activity => intentKey === '' || intentKey === activity.intent);
    }

    resetPage() {
        const {pageChangeCallback} = this.props;

        pageChangeCallback(1);
    }

    render() {
        const {page, activities, loading, colourTheme, intentKey, bannerPublication, userHasPremium} = this.props;
        const {bannerVisible} = this.state;
        const numActivitiesPerPage = parseInt(Config.get('numActivitiesPerPage'), 10);

        const activitiesFiltered = this.filterActivities(activities, intentKey);
        const numActivities = activitiesFiltered.length;

        // 1 kvuli zobrazeni o jednoho elementu mene na prvni strance
        const countHidden = activitiesFiltered.length - page * numActivitiesPerPage + 1;
        const countNextPage = countHidden < numActivitiesPerPage ? countHidden : numActivitiesPerPage;

        const isQuarterLayout = !(!userHasPremium && bannerVisible);

        if (numActivities === 0 && !loading && this.props.onlyContentPack && this.props.userIsLoggedIn) {
            return (
                <div className="container" style={{height: '293px'}}>
                    <div className="row">
                        <p style={{
                            textAlign: 'center',
                            width: '100%',
                            lineHeight: '100px',
                            fontSize: '2em',
                            fontWeight: 'bold',
                        }}>
                            <FormattedMessage
                                id='invalid_activities_filter_combination_no_content'
                                defaultMessage='Pro zvolený filtr nemáte zakoupeny žádné obsahové balíčky.'
                            />
                        </p>
                        <p className='text-center'>
                            <FormattedMessage defaultMessage='Nic tu zatím není, ale může být! Prozkoumejte naši nabídku prémiového obsahu a získejte přístup ke zcela novým aktivitám!' />
                        </p>
                        <p className='text-center'>
                            <a className='btn btn-primary' href='/obsahove-balicky/vypis'>
                                <FormattedMessage
                                    defaultMessage='Přejít k nabídce' />
                            </a>
                        </p>
                    </div>
                </div>
            );
        } else if (numActivities === 0 && !loading && this.props.onlyContentPack && !this.props.userIsLoggedIn) {
            return (
                <div className="container" style={{height: '293px'}}>
                    <div className="row">
                        <p style={{
                            textAlign: 'center',
                            width: '100%',
                            lineHeight: '293px',
                            fontSize: '2em',
                            fontWeight: 'bold',
                        }}>
                            <FormattedMessage
                                id='invalid_activities_filter_combination_no_logged'
                                defaultMessage='Pro zobrazení zakoupeného obsahu je nutné se přihlásit.'
                            />
                        </p>
                    </div>
                </div>
            );
        } else if (numActivities === 0 && !loading && !this.props.onlyContentPack) {
            return (
                <div className="container" style={{height: '293px'}}>
                    <div className="row">
                        <p style={{
                            textAlign: 'center',
                            width: '100%',
                            lineHeight: '293px',
                            fontSize: '2em',
                            fontWeight: 'bold',
                        }}>
                            <FormattedMessage
                                id='invalid_activities_filter_combination'
                                defaultMessage='Tato kombinace filtru a typu aktivity není platná. Zvolte prosím jiný typ aktivity.'
                            />
                        </p>
                    </div>
                </div>
            );
        }

        if (numActivities < 5 && !userHasPremium) {
            for (let i = numActivities; i < 4; i++) {
                activitiesFiltered.push({
                    blank: true,
                    id: 'blank' + i,
                    labelClass: {},
                    labelSubject: {},
                    labelSubtopic: {},
                });
            }
        }

        const countFirstPageHidden = userHasPremium ? 0 : 2;

        if (window.adsNotification) {
            window.adsNotification();
        }

        if (window.reloadAds) {
            window.reloadAds('da_banner_1');
        }

        return (
            <section className={'section section--full p-0' + (loading ? ' overlay' : '')} id="activity-list">
                <div className="container p-0 activity-list">
                    <div className={"card-deck card-deck--compact " + (colourTheme || 'fyzika') + '--primary'}>
                        <div className={'card-deck-layout'}>

                            {activitiesFiltered.map((activity, index) => {
                                    const fragments = [];

                                    if (((index === 4 && numActivities >= 4) || (numActivities < 4 && index + 1 === numActivities)) && !userHasPremium && bannerVisible) {
                                        fragments.push(
                                            <div data-groups={'["banner"]'} key={"inline-banner-ads"}
                                               className={'marketing-banner-inline'}>
                                                <div id="da_banner_1" className="d-flex justify-content-center flex-grow-1" />
                                                <div className="text-end text-14 adv-text pe-3">REKLAMA</div>
                                            </div>
                                            );
                                    }

                                    if (page * numActivitiesPerPage - ((numActivities >= numActivitiesPerPage) ? countFirstPageHidden : 0) > index) {
                                        fragments.push(<ActivityEntry
                                            key={activity.id}
                                            id={activity.id}
                                            iterationIndex={index}
                                            nameClass={activity.classLabel?.name}
                                            nameSubject={activity.subjectLabel?.name}
                                            nameSubtopic={activity.labelSubtopic?.name}
                                            activityLink={activity.detailUrl}
                                            activityName={activity.name}
                                            activityType={{key: activity.type, name: activity.typeName}}
                                            activityIntent={{key: activity.intent, name: activity.intentName}}
                                            withEvaluation={activity.withEvaluation}
                                            difficulty={activity.difficultyLevel}
                                            seen={activity?.seen}
                                            colourTheme={colourTheme}
                                            blank={activity.blank}
                                            hasPermission={activity.hasPermission}
                                            inContentPack={activity.inContentPack}
                                            automaticLanguages={activity.automaticLanguages}
                                            isPcPreferred={activity.isPcPreferred}
                                        />);
                                    }

                                    return fragments;
                                }
                            )}
                        </div>

                        {countNextPage > 0 &&
                            <a className="btn rounded-pill btn--yellow mx-auto text-black mb-4 px-4 py-3 mh-auto"
                               onClick={() => {
                                   this.loadNextPage();
                               }}>
                                <FormattedMessage
                                    id='load_more_activities'
                                    defaultMessage='Načíst dalších {count} cvičení'
                                    values={{count: countNextPage}}
                                />
                            </a>
                        }
                    </div>
                    {bannerPublication && bannerPublication.name && bannerVisible &&
                        <div className={'marketing-banner fixed ' + (colourTheme || 'fyzika') + '--primary'}>
                            <div className="book-close" onClick={this.hideBanner}>
                                <FormattedMessage
                                    id='filter_activity_suggestion_close'
                                    defaultMessage='Zavřít doporučení'
                                />
                                <div className="icon">&times;</div>
                            </div>
                            <div className="marketing-banner__background"/>
                            <div className="marketing-banner__content">
                                <div className="book-image">
                                    <div className="tip">
                                        <FormattedMessage
                                            id='filter_activity_suggestion_top'
                                            defaultMessage='náš tip'
                                        />
                                    </div>
                                    <img src={bannerPublication.picture}/>
                                </div>
                                <div className="book-title">{bannerPublication.name}</div>
                                <div className="book-claim">{bannerPublication.description}</div>
                                <a className="btn btn-sm btn-green" href={bannerPublication.link}>
                                    <FormattedMessage
                                        id='filter_activity_suggestion_more_info'
                                        defaultMessage='Bližší informace'
                                    />
                                </a>
                            </div>
                        </div>
                    }
                </div>
            </section>
        );
    }
}

ActivityList.propTypes = {
    activities: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            link: PropTypes.string,
            type: PropTypes.shape({
                key: PropTypes.string.isRequired,
                name: PropTypes.string.isRequired,
            }),
            intent: PropTypes.shape({
                key: PropTypes.string.isRequired,
                name: PropTypes.string.isRequired,
            }),
            labelClass: PropTypes.shape({
                name: PropTypes.string,
            }),
            labelSubject: PropTypes.shape({
                name: PropTypes.string,
            }),
            labelSubtopic: PropTypes.shape({
                name: PropTypes.string,
            }),
            withEvaluation: PropTypes.bool,
            difficulty: PropTypes.string,
        })
    ),
    bannerPublication: PropTypes.object,
    loading: PropTypes.bool,
    colourTheme: PropTypes.string,
    intentKey: PropTypes.string.isRequired,
    pageChangeCallback: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    userHasPremium: PropTypes.bool,
    onlyContentPack: PropTypes.bool,
    userIsLoggedIn: PropTypes.bool,
};

export default ActivityList;
